import{jsxs as e,jsx as r}from"react/jsx-runtime";import t from"./PillSkeleton.es.js";const m=()=>e("div",{children:[r("div",{className:"mb-3 h-5 w-28 rounded-md bg-gray-300"}),r(t,{length:5})]});export{m as default};
